import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 24px;
  padding: 24px;
  background-color: ${(props) => props.theme.colors.primary};
  .menuItens {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    .esqItens {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      margin-bottom: 24px;
    }
  }
  .totalPesoValor {
    ul {
      list-style: none;
      display: flex;
      margin: 0;
      padding: 0;
      li {
        font-size: 14px;
        position: relative;
        padding: 0 5px;
      }
      li + li:before {
        content: '|';
        left: -1px;
        position: absolute;
      }
    }
  }
  .outlineBtn {
    color: #096dd9;
    background-color: transparent;
    border-color: #096dd9;
    font-size: 14px;
    margin: 0 1rem;
  }
  .btn {
    color: #fff;
    font-weight: 600;
    background-color: #096dd9;
    border-color: #096dd9;
    font-size: 14px;
  }
`;

export const ContFilter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  font-size: 14px;
  margin-right: 10px;

  svg {
    margin-right: 2px;
  }

  p {
    margin-right: 10px;
  }
`;
